import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './IndigoPriceList.css';

/**
 * Static INDIGO service price list. All text comes from i18n so language
 * switches "on the fly" when the user changes language in the header.
 */
const IndigoPriceList = () => {
  const { t } = useLanguage();

  return (
    <div className="indigo-price">
      <h2>{t('priceList.title')}</h2>
      <div className="subhead">
        <strong>{t('priceList.subhead')}</strong>
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>{t('priceList.colNo')}</th>
              <th>{t('priceList.colService')}</th>
              <th>{t('priceList.colCost')}</th>
              <th>{t('priceList.colNote')}</th>
            </tr>
          </thead>
          <tbody>
            <tr className="main-row">
              <td className="service-id">1</td>
              <td className="service-name">{t('priceList.r1_name')}</td>
              <td className="service-price">2,0</td>
              <td className="service-note">{t('priceList.r1_note')}</td>
            </tr>
            <tr className="main-row">
              <td>2</td>
              <td className="service-name">{t('priceList.r2_name')}</td>
              <td className="service-price">5,5</td>
              <td className="service-note">{t('priceList.r2_note')}</td>
            </tr>
            <tr className="main-row">
              <td>3</td>
              <td className="service-name">{t('priceList.r3_name')}</td>
              <td className="service-price">2,0</td>
              <td className="service-note">{t('priceList.r3_note')}</td>
            </tr>
            <tr className="main-row">
              <td>4</td>
              <td className="service-name">{t('priceList.r4_name')}</td>
              <td className="service-price">3,5</td>
              <td className="service-note">{t('priceList.r4_note')}</td>
            </tr>
            <tr className="main-row">
              <td rowSpan={8} style={{ verticalAlign: 'middle', backgroundColor: '#F4F9FF' }}>5</td>
              <td colSpan={3} style={{ backgroundColor: '#F4F9FF', fontWeight: 600, color: '#022B54' }}>
                {t('priceList.r5_main')}
              </td>
            </tr>
            <tr className="sub-row">
              <td className="service-name">{t('priceList.r5_50_name')}</td>
              <td className="service-price">10,5</td>
              <td className="service-note">{t('priceList.r5_50_note')}</td>
            </tr>
            <tr className="sub-row">
              <td className="service-name">{t('priceList.r5_80_name')}</td>
              <td className="service-price">14,0</td>
              <td className="service-note">{t('priceList.r5_80_note')}</td>
            </tr>
            <tr className="sub-row">
              <td className="service-name">{t('priceList.r5_100_name')}</td>
              <td className="service-price">15,5</td>
              <td className="service-note">{t('priceList.r5_100_note')}</td>
            </tr>
            <tr className="sub-row">
              <td className="service-name">{t('priceList.r5_120_name')}</td>
              <td className="service-price">19,0</td>
              <td className="service-note">{t('priceList.r5_120_note')}</td>
            </tr>
            <tr className="sub-row">
              <td className="service-name">{t('priceList.r5_180_name')}</td>
              <td className="service-price">26,0</td>
              <td className="service-note">{t('priceList.r5_180_note')}</td>
            </tr>
            <tr className="sub-row">
              <td className="service-name">{t('priceList.r5_220_name')}</td>
              <td className="service-price">45,0</td>
              <td className="service-note">{t('priceList.r5_220_note')}</td>
            </tr>
            <tr className="sub-row">
              <td className="service-name">{t('priceList.r5_oversized_name')}</td>
              <td className="service-price">90,0</td>
              <td className="service-note">{t('priceList.r5_oversized_note')}</td>
            </tr>
            <tr className="main-row">
              <td>6</td>
              <td className="service-name">{t('priceList.r6_name')}</td>
              <td className="service-price">13,5</td>
              <td className="service-note">{t('priceList.r6_note')}</td>
            </tr>
            <tr className="main-row">
              <td>7</td>
              <td className="service-name">{t('priceList.r7_name')}</td>
              <td className="service-price">3,5</td>
              <td className="service-note">{t('priceList.r7_note')}</td>
            </tr>
            <tr className="main-row">
              <td>8</td>
              <td className="service-name">{t('priceList.r8_name')}</td>
              <td className="service-price">{t('priceList.r8_price')}</td>
              <td className="service-note">{t('priceList.r8_note')}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="info-box">
        <p><strong>{t('priceList.infoTitle')}</strong></p>
        <p>• {t('priceList.info1')}</p>
        <p>• {t('priceList.info2')}</p>
        <p>• {t('priceList.info3')}</p>
        <p>• {t('priceList.info4')}</p>
      </div>
    </div>
  );
};

export default IndigoPriceList;
